export default __webpack_public_path__ + "static/media/illustration_esports.11ffb7ba.png";